import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PermissionsGuardService } from "src/app/shared/services/permissions-guard.service";
import { AnnouncementsComponent } from "./components/announcements/announcements.component";
import { CrmComponent } from "./components/crm/crm.component";
import { MakeAdjustmentComponent } from "./components/make-adjustment/make-adjustment.component";
import { MangementComponent } from "./components/mangement/mangement.component";
import { ManualPaymentComponent } from "./components/manual-payment/manual-payment.component";
import { AuthGuardService as AuthGuard } from '../../../shared/services/auth.guard';

const actionRoutes: Routes = [
  {
    path: 'announcements',
    component: AnnouncementsComponent,
    canActivate: [PermissionsGuardService, AuthGuard]
  },
  {
    path: 'make-adjustment',
    component: MakeAdjustmentComponent,
    canActivate: [PermissionsGuardService, AuthGuard]
  },
  {
    path: 'mangement',
    component: MangementComponent,
    canActivate: [PermissionsGuardService, AuthGuard]
  },
  {
    path: 'reports/crm',
    component: CrmComponent,
    canActivate: [PermissionsGuardService]
  },
  {
    path: 'manualPayment',
    component: ManualPaymentComponent,
    canActivate: [PermissionsGuardService, AuthGuard]
  },
  {
    path: 'advertisement-banner',
    canActivate: [PermissionsGuardService],
    loadChildren:
      () => import('./components/banner/banner.module')
        .then(m => m.AdvertisementBannerModule)
  },
  { path: 'providers',canActivate:[PermissionsGuardService], loadChildren: () => import('./components/gate/provider/provider.module').then(m => m.ProivderModule) },
  { path: 'merchants',canActivate:[PermissionsGuardService], loadChildren: () => import('./components/gate/merchant/merchant.module').then(m => m.MerchantModule) },
  { path: 'fraud/module',canActivate:[PermissionsGuardService],canActivateChild:[PermissionsGuardService], loadChildren: () => import('./components/gate/fraud-module/fraud-module.module').then(m => m.FraudModuleModule) },
  { path: 'fraud/statement',canActivateChild:[PermissionsGuardService],loadChildren: () => import('./components/gate/fraud-statment/fraud-statment.module').then(m => m.FraudStatmentModule)},
  { path: 'bin-providers',canActivateChild:[PermissionsGuardService],loadChildren: () => import('./components/gate/bin-provider/bin-provider.module').then(m => m.BinProviderModule)},


  {
    path: 'roles',
    loadChildren: () => import('./components/roles/role.module').then(m => m.RoleModule)
  },
  {
    path: 'admin',
    canActivate: [AuthGuard],
    loadChildren: () => import('./components/create-admin/admin.module').then(m => m.AdminModule)
  },

  {
    path: 'crm/profile/:id',
    loadChildren: () =>
      import('./components/crm/profile/profile.module').then(m => m.ProfileModule),
  },
  {
    path: 'systemPromocode',
    canActivate: [PermissionsGuardService,AuthGuard],
    loadChildren: () => import('./components/promocode/promocode.module').then(m => m.PromocodeModule)
  },
  { path: 'bill-categories',canActivate:[PermissionsGuardService], loadChildren: () => import('./components/bill-payments/bill-category/bill-category.module').then(m => m.BillCategoryModule) },
  { path: 'bill-providers',canActivate:[PermissionsGuardService], loadChildren: () => import('./components/bill-payments/bill-provider/bill-provider.module').then(m => m.BillProviderModule) },
  { path: 'bill-services',canActivate:[PermissionsGuardService], loadChildren: () => import('./components/bill-payments/bill-service/bill-service.module').then(m => m.BillServiceModule) },
  { path: 'bill-limits',canActivate:[PermissionsGuardService], loadChildren: () => import('./components/bill-payments/bill-limits/bill-limits.module').then(m => m.BillLimitsModule) },
];


@NgModule({
  imports: [RouterModule.forChild(actionRoutes)],
  exports: [RouterModule]
})
export class ActionRoutingModule { }
